// extracted by mini-css-extract-plugin
export var errorBanner = "_cg-2";
export var scroller = "_cg-0";
export var thinking = "_cg-1";
export var visuallyHidden = "_cg-3";